const AiContentGeneratorTab = () => {
  return (
    <>
      <div className="ail-feature-area pt-60 pb-120">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-8">
              <p className="ail-sub-title text-black fw-500 ah-input-bg d-inline-flex align-items-center gap-2 rounded-5 mb-20">
                <span className="ail-gd-bg"></span> Featured
              </p>
              <h2 className="ail-title text-black fs-48 fw-600">
                What amazing content will you{" "}
                <span className="ail-highlighted-text">create with AI</span> ?
              </h2>
            </div>
            <div className="col-xl-5 col-lg-4">
              <div className="text-end">
                <div className="p-3 d-inline-flex justify-content-end  rounded-circle">
                  <a
                    href=""
                    className="aih-arrow-btn d-inline-flex align-items-center justify-content-center position-relative"
                  >
                    <svg
                      width="24"
                      height="39"
                      viewBox="0 0 24 39"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.5 2C13.5 1.17157 12.8284 0.5 12 0.5C11.1716 0.5 10.5 1.17157 10.5 2L13.5 2ZM10.9393 38.0607C11.5251 38.6464 12.4749 38.6464 13.0607 38.0607L22.6066 28.5147C23.1924 27.9289 23.1924 26.9792 22.6066 26.3934C22.0208 25.8076 21.0711 25.8076 20.4853 26.3934L12 34.8787L3.51472 26.3934C2.92893 25.8076 1.97919 25.8076 1.3934 26.3934C0.807613 26.9792 0.807613 27.9289 1.3934 28.5147L10.9393 38.0607ZM10.5 2L10.5 37L13.5 37L13.5 2L10.5 2Z"
                        fill="#666666"
                      ></path>
                    </svg>
                    <img
                      className="aih-arrow-btn-img rotate-ani position-absolute"
                      src="assets/img/ail_home/arrow-btn.png"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-40">
            <div className="row">
              <div className="col-12">
                <ul
                  className="nav ail-feature-tab align-items-center justify-content-between gap-2 mb-0"
                  id="nav-tab"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      href="#tab-1"
                      data-bs-toggle="tab"
                      data-bs-target="#tab-1"
                      role="tab"
                      aria-selected="false"
                    >
                      <img src="assets/img/ail_home/ft-icon-1.png" alt="" />
                      <img
                        src="assets/img/ail_home/ft-icon-1-gd.png"
                        alt=""
                        className="active"
                      />
                      <p>Social Media</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#tab-2"
                      data-bs-toggle="tab"
                      data-bs-target="#tab-2"
                      role="tab"
                      aria-selected="false"
                    >
                      <img src="assets/img/ail_home/ft-icon-2.png" alt="" />
                      <img
                        src="assets/img/ail_home/ft-icon-2-gd.png"
                        alt=""
                        className="active"
                      />
                      <p>Advertising</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#tab-3"
                      data-bs-toggle="tab"
                      data-bs-target="#tab-3"
                      role="tab"
                      aria-selected="false"
                    >
                      <img src="assets/img/ail_home/ft-icon-3.png" alt="" />
                      <img
                        src="assets/img/ail_home/ft-icon-3-gd.png"
                        alt=""
                        className="active"
                      />
                      <p>Tools and templates</p>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#tab-4"
                      data-bs-toggle="tab"
                      data-bs-target="#tab-4"
                      role="tab"
                      aria-selected="false"
                    >
                      <img src="assets/img/ail_home/ft-icon-4.png" alt="" />
                      <img
                        src="assets/img/ail_home/ft-icon-4-gd.png"
                        alt=""
                        className="active"
                      />
                      <p>Write in Any Language</p>
                    </a>
                  </li>
                </ul>
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade pt-40 active show"
                    id="tab-1"
                    role="tabpanel"
                  >
                    <div className="ail-ft-content ail-main-bg p-5 pt-60 pb-60 rounded-10 position-relative z-1 overflow-hidden">
                      <div className="row align-items-center">
                        <div className="col-lg-6">
                          <div className="ail-op-bg p-4 rounded-10">
                            <img
                              src="assets/img/ail_home/tab-1.png"
                              alt=""
                              className="w-100 img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="ail-tab-con pl-15">
                            <h3 className="text-black fs-30 mb-20">
                              Generate months of social media content in minutes
                            </h3>
                            <p className="mb-20">
                              Holisticly incentivize pandemic channels and
                              cross-unit solutions. Quickly formulate
                              mission-critical catalysts for change.
                            </p>
                            <ul className="ail-tab-con_list list-unstyled">
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Publish entertaining LinkedIn articles.
                                </p>
                              </li>
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Using our AI tools and pre-built template to
                                  create content briefs write and optimize
                                  content in one place.
                                </p>
                              </li>
                            </ul>
                            <a
                              href=""
                              className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                            >
                              Get Started Now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade pt-40"
                    id="tab-2"
                    role="tabpanel"
                  >
                    <div className="ail-ft-content ail-main-bg p-5 pt-60 pb-60 rounded-10 position-relative z-1 overflow-hidden">
                      <div className="row align-items-center">
                        <div className="col-lg-6">
                          <div className="ail-op-bg p-4 rounded-10">
                            <img
                              src="assets/img/ail_home/tab-1.png"
                              alt=""
                              className="w-100 img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="ail-tab-con pl-15">
                            <h3 className="text-black fs-30 mb-20">
                              Generate months of social media content in minutes
                            </h3>
                            <p className="mb-20">
                              Holisticly incentivize pandemic channels and
                              cross-unit solutions. Quickly formulate
                              mission-critical catalysts for change.
                            </p>
                            <ul className="ail-tab-con_list list-unstyled">
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Publish entertaining LinkedIn articles.
                                </p>
                              </li>
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Using our AI tools and pre-built template to
                                  create content briefs write and optimize
                                  content in one place.
                                </p>
                              </li>
                            </ul>
                            <a
                              href=""
                              className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                            >
                              Get Started Now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade pt-40"
                    id="tab-3"
                    role="tabpanel"
                  >
                    <div className="ail-ft-content ail-main-bg p-5 pt-60 pb-60 rounded-10 position-relative z-1 overflow-hidden">
                      <div className="row align-items-center">
                        <div className="col-lg-6">
                          <div className="ail-op-bg p-4 rounded-10">
                            <img
                              src="assets/img/ail_home/tab-1.png"
                              alt=""
                              className="w-100 img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="ail-tab-con pl-15">
                            <h3 className="text-black fs-30 mb-20">
                              Generate months of social media content in minutes
                            </h3>
                            <p className="mb-20">
                              Holisticly incentivize pandemic channels and
                              cross-unit solutions. Quickly formulate
                              mission-critical catalysts for change.
                            </p>
                            <ul className="ail-tab-con_list list-unstyled">
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Publish entertaining LinkedIn articles.
                                </p>
                              </li>
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Using our AI tools and pre-built template to
                                  create content briefs write and optimize
                                  content in one place.
                                </p>
                              </li>
                            </ul>
                            <a
                              href=""
                              className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                            >
                              Get Started Now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade pt-40"
                    id="tab-4"
                    role="tabpanel"
                  >
                    <div className="ail-ft-content ail-main-bg p-5 pt-60 pb-60 rounded-10 position-relative z-1 overflow-hidden">
                      <div className="row align-items-center">
                        <div className="col-lg-6">
                          <div className="ail-op-bg p-4 rounded-10">
                            <img
                              src="assets/img/ail_home/tab-1.png"
                              alt=""
                              className="w-100 img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="ail-tab-con pl-15">
                            <h3 className="text-black fs-30 mb-20">
                              Generate months of social media content in minutes
                            </h3>
                            <p className="mb-20">
                              Holisticly incentivize pandemic channels and
                              cross-unit solutions. Quickly formulate
                              mission-critical catalysts for change.
                            </p>
                            <ul className="ail-tab-con_list list-unstyled">
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Publish entertaining LinkedIn articles.
                                </p>
                              </li>
                              <li className="d-flex align-items-center gap-3">
                                <span>
                                  <i className="fa-solid fa-chevron-right"></i>
                                </span>
                                <p className="text-black mb-0">
                                  Using our AI tools and pre-built template to
                                  create content briefs write and optimize
                                  content in one place.
                                </p>
                              </li>
                            </ul>
                            <a
                              href=""
                              className="btn ail-gd-bg dark-bg-hover rounded-5 text-white fs-16 border-0 mt-20"
                            >
                              Get Started Now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentGeneratorTab;
